
export const customerIdentificationWidgets = {
  customerAuthenticationPage: 'CustomerAuthentication',
  otpPage: 'OtpWidget',
  customerInfoPage: 'CustomerInfo'
}

export const setAppointmentWidgets = {
  setAppointmentPage: 'SetAppointmentPage',
  successPage: 'SuccessPage',
  cancelationPage: 'CancelationPage'
}

export const appointmentDetailsWidgets = {
  appointmentDetailsPage: 'appointmentDetailsPage',
  cancelationPage: 'CancelationPage'
}